export const props = {
    macroList: {
        type: Array,
        default: function () {
            return []
        }
    },
    icon: {
        type: String,
        default: "location-arrow"
    },
    label: {
        type: String,
        default: "More Actions"
    },
    labelIcon:{
        type: String,
        default: "caret-right"
    },
    containerWith:{
        type: String,
        default: "14rem"
    },
    listPosition:{
        type: String,
        default: "left"
    }
}

export const macroLoadFlag = function (resolve, reject) {
    macroLoadFlag.resolve = resolve;
    macroLoadFlag.reject = reject;
}

export const macroLoadPromise = new Promise(macroLoadFlag);